import { render, staticRenderFns } from "./FormEmployeeDados.vue?vue&type=template&id=5a5f5d27"
import script from "./FormEmployeeDados.vue?vue&type=script&lang=js"
export * from "./FormEmployeeDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports